import React from "react"

export default (props) => {
  const style = props.node.style || "normal"

  switch (style) {
    case "h2":
      return <h2>{props.children}</h2>
    case "h3":
      return <h3>{props.children}</h3>
    case "h4":
      return <h4>{props.children}</h4>
    case "normal":
      return <p>{props.children}</p>
    case "intro":
      return <p className="intro">{props.children}</p>
    case "accent":
      return <p className="accent">{props.children}</p>
    default:
      return <p>{props.children}</p>
  }
}
